import styles from "./select.module.scss";
export interface Option {
  value: string | number;
  label: string;
}
interface Props {
  id?: string;
  required?: boolean;
  placeholder?: string;
  name: string;
  options: Option[] | undefined;
  onChange?: React.ChangeEventHandler<HTMLSelectElement> | undefined;
  value?: string | number;
  disabled?: boolean;
}
const Select = ({
  id,
  name,
  options,
  onChange,
  placeholder,
  disabled = false,
  required,
  value = "",
}: Props) => {
  return (
    <div className={styles.selectContainer}>
      {placeholder && (
        <label className={styles.label} htmlFor="">
          {`${placeholder} ${required ? "*" : ""}`}
        </label>
      )}
      <select
        id={id}
        data-testid={id}
        required={required}
        onChange={onChange}
        value={value}
        name={name}
        disabled={disabled}
        className={styles.select}
      >
        <option disabled value={""}>
          {`${name} ${required ? "*" : ""}`}
        </option>
        {(options ?? []).map((option, index) => {
          return (
            <option key={index} label={option.label} value={option.value}>
              {option.label}
            </option>
          );
        })}
      </select>
    </div>
  );
};

export default Select;
